// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__Peb6h","selects":"Documents_selects__3y92C"};